module.exports = __webpack_public_path__ + "img/wa_logo.c0da6511.svg";